// extracted by mini-css-extract-plugin
export default {"percentage-box-container":"VotesPercentageBox_percentage-box-container__jwIH5","percentage-text":"VotesPercentageBox_percentage-text__Slptv"};